import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

/**
 * Uses state with localStorage as the backing store.
 * @param {String} key
 * @returns {[any, React.Dispatch<any>]}
 */
function useLocalStorage(key) {
  const history = useHistory();

  if (!key) throw "param 'key' cannot be empty";

  let item;
  try {
    item = JSON.parse(localStorage.getItem(key));
  } catch (error) {
    item = localStorage.getItem(key);
  }

  const onStorageUpdate = (e) => {
    if (localStorage && localStorage.getItem("expired-key")) {
      const previousSession = JSON.parse(localStorage.getItem("expired-key"));
      if (previousSession) {
        history?.push("/logout");
      }
    }
  };

  useEffect(() => {
    window.addEventListener("storage", onStorageUpdate);
    return () => {
      window.removeEventListener("storage", onStorageUpdate);
    };
  }, []);

  // We read value from sessionStrage rather than the hook, but call set to trigger React re-render.
  const [, setItem] = useState(item);

  const set = (data) => {
    if (data === null || data === undefined) {
      localStorage.removeItem(key);
      if (key === "vip-patron-session" && item) {
        localStorage.setItem("expired-key", JSON.stringify(item.sessionId));
      }
    } else {
      localStorage.setItem(key, JSON.stringify(data));
      setItem(data);
      if (key === "vip-patron-session") {
        if (localStorage.getItem("expired-key")) {
          localStorage.removeItem("expired-key");
        }
      }
    }
    localStorage.setItem(key, JSON.stringify(data));
  };

  return [item, set];
}

export default useLocalStorage;
